module.exports = "/assets/data/ff4d3d615f3dd75c073b312695a8b6bf-CM0.data.json";